module.exports = __webpack_public_path__ + "img/zlxcy.37286af.png";